import { AfterViewInit, Directive, Input, OnDestroy } from "@angular/core";

@Directive({
    selector: "[triggerBinding]",
})
export class TriggerBindingDirective {
    @Input("triggerBinding") public context: any;
}

@Directive({
    selector: "[triggerWhenReady]",
})
export class TriggerWhenReadyDirective implements AfterViewInit {
    @Input() public triggerWhenReady: () => void;
    @Input() public triggerWhenReadyArgs: any[] = [];

    constructor(private binding: TriggerBindingDirective) {
    }

    public ngAfterViewInit(): void {
        callTrigger(
            this.triggerWhenReady,
            this.triggerWhenReadyArgs,
            this.binding.context,
        );
    }
}

@Directive({
    selector: "[triggerWhenDestroyed]",
})
export class TriggerWhenDestroyedDirective implements OnDestroy {
    @Input() public triggerWhenDestroyed: () => void;
    @Input() public triggerWhenDestroyedArgs: any[] = [];

    constructor(private binding: TriggerBindingDirective) {
    }

    public ngOnDestroy(): void {
        callTrigger(
            this.triggerWhenDestroyed,
            this.triggerWhenDestroyedArgs,
            this.binding.context,
        );
    }
}

function callTrigger(func: () => void, args, context): void {
    if (!!context) {
        func = func.bind(context);
    }
    // @ts-ignore
    func(...args);
}
